<script setup>
import Image from "~/components/atoms/Image.vue";
import {useCurrencyStore} from "~/store/currencyStore.js";
import DefaultCarousel from "~/components/molecules/Carousel.vue";

const {isDesktop} = useDevice();
const store = useCurrencyStore();

const props = defineProps({
  data: Object
})

const makeStyle = (item) => {
  return {
    top: (isDesktop ? item.top.top : item.top.top_phone) + '%',
    left: (isDesktop ? item.left.left : item.left.left_phone) + '%',
    right: (isDesktop ? item.right.right : item.right.right_phone) + '%',
    bottom: (isDesktop ? item.bottom.bottom : item.bottom.bottom_phone) + '%',
    zIndex: 100
  }
}
</script>

<template>
  <div class="carousel-plugin">
    <DefaultCarousel :infinity="true" :items="data.carousel" :items-to-scroll="2.3" :items-to-show-mobile="2.1"
                     :items-to-show-tablet="3.3"
                     :items-to-show="5">
      <template #default="{item,index}">
        <nuxt-link :to="item.url"
                   class="product-preview product animate__animated animate__fadeIn">
          <div class="carousel-plugin-item" :class="'carousel-item-'+(index+1)">
            <div v-if="item.hc_recommended_price && item.hc_volume_price" class="text-carousel-item"
                 :style="makeStyle(item)">
              <p
                  class="name carousel-item-1">{{ item.label_title }}</p>
              <p class="price carousel-item-1">{{ item.hc_volume_price }} {{ store.currency }}</p>
              <p class="old-price carousel-item-1">{{ item.hc_recommended_price }} {{ store.currency }}</p></div>

            <div class="image">
              <Image :mobile-src="item.file.small" :src="item.file.preview"/>
            </div>
          </div>
        </nuxt-link>
      </template>
    </DefaultCarousel>
  </div>
</template>

<style scoped lang="scss">
.carousel-plugin {
  margin: 0 -60px;

  @include small-desktop {
    margin: 0;
  }

  @include smd {
    margin: 0;
  }

  &:deep(.carousel__track) {
    margin-bottom: 0;
    margin-top: 0;
  }

  .carousel-plugin-item {
    height: 100%;
  }

  a {
    width: 100%;
    padding: 0 11px;
    aspect-ratio: 1 / 0.8;

    @include mobile {
      padding: 0;

      aspect-ratio: 1 / 1;
    }

    .image {
      @include smd {
        max-height: 200px;
      }

      @include mobile {
        max-height: unset;
        margin-right: 10px;
        aspect-ratio: 1/1;
      }
    }

    .text-carousel-item {
      position: absolute;
      padding: 3px 0 6px 10px;
      font-size: 16px;
      font-weight: 400;
      max-width: 200px;
      bottom: 50px;
      color: $black;
      width: 166px;
      min-height: 74px;
      height: fit-content;
      max-height: 100px;
      background-color: rgba(251, 252, 251, .6);
      text-align: left;

      @include smd {
        max-width: 114px;
        height: fit-content;
        padding: 5px 8px 4px;
        min-height: unset;
        max-height: unset;
      }

      .name {
        font-size: 14px;
        line-height: normal;

        @include smd {
          font-size: 10px;
          line-height: 10px;
        }
      }

      .price {
        font-size: 19px;
        font-weight: 600;

        @include smd {
          font-size: 13px;
        }
      }

      .old-price {
        font-size: 12px;
        text-decoration: line-through;

        @include smd {
          font-size: 8px;
        }
      }
    }
  }

  li:first-child a {
    padding-left: 0;
  }

  li:last-child a {
    padding-right: 0;
  }

}
</style>
